import React from 'react';
import { OrganizationFileResponse } from '@server/application/files/types/file.types';
import { CellContext } from '@tanstack/react-table';
import { Form } from 'antd';
import { LabelsSelect } from '@/entities/file';
import { useKnowledgeBaseFileExplorerContext } from '@/widgets/knowledge-base/KnowledgeBaseFileExplorerContext';

export const FileExplorerLabelColumn = <TValue,>({
  row: { original: file },
}: CellContext<OrganizationFileResponse, TValue>) => {
  const {
    labels = [],
    onLabelSelect,
    onLabelDeselect,
    onLabelCreate,
  } = useKnowledgeBaseFileExplorerContext();

  return (
    <Form.Item style={{ margin: 0 }}>
      <LabelsSelect
        file={file}
        labels={labels}
        onLabelSelect={onLabelSelect}
        onLabelDeselect={onLabelDeselect}
        onLabelCreate={onLabelCreate}
      />
    </Form.Item>
  );
};
